export default class PathJobResumeDetailDto {
    Scope: string;
    Type: string;
    Level: string;
    Details: string;

    constructor(
        scope: string,
        type: string,
        level: string,
        details: string
    ) {
        this.Scope = scope;
        this.Type = type;
        this.Level = level;
        this.Details = details;
    }
}